export enum ETokenType {
  Activation = 'Activation',
  PasswordReset = 'PasswordReset',
}
